import { render, staticRenderFns } from "./StoresModal.vue?vue&type=template&id=00b4c559&scoped=true"
import script from "./StoresModal.vue?vue&type=script&lang=js"
export * from "./StoresModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b4c559",
  null
  
)

export default component.exports